import { render, staticRenderFns } from "./ItemListOrdine.vue?vue&type=template&id=17bc0140"
import script from "./ItemListOrdine.vue?vue&type=script&lang=ts"
export * from "./ItemListOrdine.vue?vue&type=script&lang=ts"
import style0 from "./ItemListOrdine.vue?vue&type=style&index=0&id=17bc0140&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17bc0140')) {
      api.createRecord('17bc0140', component.options)
    } else {
      api.reload('17bc0140', component.options)
    }
    module.hot.accept("./ItemListOrdine.vue?vue&type=template&id=17bc0140", function () {
      api.rerender('17bc0140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ItemListOrdine.vue"
export default component.exports